import React from "react";

import MySuhbatMark from "./MySuhbatMark";

/**
 * Product lockup: the mark, "MySuhbat" with "My" in the panel's blue, and
 * which app this is underneath. `compact` is the mark alone, for the
 * icon-only rail.
 *
 * Until 2026-10-22 this was text only, on purpose, because no mark existed;
 * the tech lead asked for one, and MySuhbatMark is it.
 */
const MySuhbatLogo = ({ compact = false }) => (
  <span className="ms-lockup">
    <MySuhbatMark size={compact ? 36 : 34} />
    {!compact && (
      <span className="ms-lockup-text">
        <b>
          <em>My</em>Suhbat
        </b>
        <span className="ms-lockup-sub">Boshqaruv paneli</span>
      </span>
    )}
  </span>
);

export default MySuhbatLogo;
